import React, {useContext, useEffect, useMemo, useState} from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";

import axios from '../../../axios-defaults';
import Spinner from "../../UI/Spinner";
import SearchForm from "../../UI/SearchForm/SearchForm";
import Block from "./Block";
import UserContext from "../../../context/user-context";

const Notifications = (props) => {
    const {t, i18n} = useTranslation();
    const userContext = useContext(UserContext);

    //const outputTypes = ['email','phone','sms'];
	const outputTypes = ['email','sms'];
    const baseStructure = {
        untouched : true,
        infos: { },
        configs: { }
    };

    // State constants //
    const [loading, setLoading] = useState(0);
    const [savingStatus, setSavingStatus] = useState(false); // will show a spinner on the save button
    const [originalData, setOriginalData] = useState([]); // used for search
    const [defaultConfigs,setDefaultConfigs] = useState({}); // Settings for all accounts
    const [subaccountConfigs,setSubaccountConfigs] = useState([]); // Settings for specific accounts
    const [notificationType,setNotificationType] = useState('D');
    /////////////////////

    useEffect(async () => {
        setLoading(true);
        await getConfigs();
        setLoading(false);
    }, []);

    const getConfigs = async () => {
        await axios.get(`/subAccounts/notificationSubscriptions?notificationType=${notificationType}`)
            .then(response => {
                if(response.data.succeeded)  {
                    //console.log('[Messages.js] getConfigs() request results: ',response.data.data);

                    let subaccountsMap = [];
                    response.data.data.subAccountSubscriptionList.map(row => {
                        subaccountsMap.push({
                            ...baseStructure,
                            infos: {
                                subAccountCode: row.subAccountCode,
                                subAccountName: row.subAccountName
                            },
                            configs: parseConfigUtil(row.detailList)
                        });
                    });
                    const defaultsParsed = {
                        ...baseStructure,
                        configs: parseConfigUtil(response.data.data.allSubAccountSubscription.detailList)
                    }
                    //console.log('[Messages.js] getConfigs() Default : ',defaultsParsed);
                    //console.log('[Messages.js] getConfigs() Subaccounts : ',subaccountsMap);
                    setDefaultConfigs(defaultsParsed);
                    setSubaccountConfigs(subaccountsMap);
                    setOriginalData(subaccountsMap);
                    //setNotificationType(response.data.data.allSubAccountSubscription.notificationType);
                }
            }).catch(error => {
                console.log('[Messages.js] : Ajax error in getSubaccounts()',error.message);
            });
    }

    const matchCodeUtil = (type) => {
        // match the code used by API with the text
        let code;
        switch(type){
            //case 'phone' :  code = 'P'; break; // Phone
            case 'sms' :  code = 'M'; break; // SMS
            case 'email' : default: code = 'S'; break; // SocketLabEmail
        }
        return code;
    }

    const parseConfigUtil = (confs) => {
        //console.log('[Messages.js] parseConfigUtil() confs :',confs);
        // Just a tool to help format the data to fit the initial release of the code without having to rewrite everything
        let configsStructure = {};
        outputTypes.forEach((type) => {
            // for each output type, test the configs to match the relevent 'code' property then return a simplified array which will be stored in the config structure
            const code = matchCodeUtil(type);
            const fieldsFiltered = confs.filter( config => config.transmissionType == code );
            let fields = [];
            let isChecked = true;
            if(Array.isArray(fieldsFiltered) && fieldsFiltered.length > 0){
                fields = confs.filter( config => config.transmissionType == code ).map(config => config.value);
            }
            if(!fields.length){
                fields.push(''); // add an empty field to be filled in by user later-on
                isChecked = false;
            }

            configsStructure[type] = {
                checked : isChecked,
                fields : fields
            }
        });
        //console.log('[Messages.js] parseConfigUtil() final structure :',configsStructure);
        return configsStructure;
    }

    const manageFieldsUtil = (add,currentFields,index) => {
        let updatedFields = [];
        if(add){
            // Adding a new empty field at the end
            updatedFields = currentFields.concat(['']);
        } else {
            // Removing the field using it's index
            const deletedFields = currentFields.splice(index,1);
            updatedFields = [...currentFields];
        }

        return updatedFields;
    }

    const updateCheckedValueUtil = (isDefault,type,subaccountIndex,checked) => {
        let configsType = (isDefault) ? defaultConfigs : subaccountConfigs[subaccountIndex];
        //console.log('[Messages.js] updateCheckedValueUtil() configsType : ',configsType);
        const updatedValues = {
            ...configsType,
            untouched : false,
            configs:{
                ...configsType["configs"],
                [type]: {
                    ...configsType["configs"][type],
                    fields: (checked) ? [...configsType["configs"][type]["fields"]] : [''],
                    checked: (checked) ? true : false
                }
            }
        };
        return updatedValues;
    }

    const updateFieldsObjectUtil = (isDefault,type,subaccountIndex,fields) => {
        let configsType = (isDefault) ? defaultConfigs : subaccountConfigs[subaccountIndex];
        const updatedValues = {
            ...configsType,
            untouched : false,
            configs:{
                ...configsType["configs"],
                [type]: {
                    ...configsType["configs"][type],
                    fields: fields
                }
            }
        };
        return updatedValues;
    }

    const checkOutputTypeHandler = (subaccountIndex,type,checked,isDefault) => {
        // As a note : Default means values 'For the whole account'. Else it means for each individual subaccount
        if(isDefault){
            // Using a new object, assigning the updated values to the defaults
            const updatedValues = updateCheckedValueUtil(isDefault,type,null,checked);

            // Updating the state defaults
            return setDefaultConfigs(updatedValues);
        } else {
            // Create a new array using the current subaccounts
            const updatedSubaccounts = [...subaccountConfigs];
            // Using a new object, assigning the updated values to the subaccount
            const updatedValues = updateCheckedValueUtil(isDefault,type,subaccountIndex,checked);
            // Updating the new subaccounts array with the new subaccount object
            updatedSubaccounts[subaccountIndex] = updatedValues;

            // updating the state subaccounts using the new array
            return setSubaccountConfigs(updatedSubaccounts);
        }
    }

    const addRemoveFieldHandler = (subaccountIndex,type,add,fieldIndex,isDefault) => {
        // Extracting current values for the selected fields type
        let fields = [];
        if(isDefault) fields = [...defaultConfigs.configs[type].fields];
        else fields = [...subaccountConfigs[subaccountIndex].configs[type].fields];

        // As a note : Default means values 'For the whole account'. Else it means for each individual subaccount
        if(isDefault){
            const updatedFields = manageFieldsUtil(add,fields,fieldIndex);
            // Using a new object, assigning the updated values
            const updatedValues = updateFieldsObjectUtil(isDefault,type,null,updatedFields);

            // Updating the state defaults
            return setDefaultConfigs(updatedValues);
        } else {
            const currentFields = subaccountConfigs[subaccountIndex].configs[type].fields;
            // Create a new array using all the subaccounts that will be used to update its values
            const updatedSubaccounts = [...subaccountConfigs];
            const updatedFields = manageFieldsUtil(add,currentFields,fieldIndex);
            // Using a new object, assigning the updated values to the subaccount
            const updatedValues = updateFieldsObjectUtil(isDefault,type,subaccountIndex,updatedFields);

            // Updating the new subaccounts array with the new subaccount object
            updatedSubaccounts[subaccountIndex] = updatedValues;

            // updating the state subaccounts using the new array
            return setSubaccountConfigs(updatedSubaccounts);
        }
    }

    const inputValueHandler = (subaccountIndex,type,fieldIndex,isDefault,value) => {
        let fields = [];
        if(isDefault) fields = [...defaultConfigs.configs[type].fields];
        else fields = [...subaccountConfigs[subaccountIndex].configs[type].fields];
        fields[fieldIndex] = value;

        if(isDefault){
            // Using a new object, assigning the updated values to the defaults
            const updatedValues = updateFieldsObjectUtil(isDefault,type,null,fields);

            // Updating the state defaults
            return setDefaultConfigs(updatedValues);
        } else {
            // Using a new object, assigning the updated values to the subaccount
            const updatedValues = updateFieldsObjectUtil(isDefault,type,subaccountIndex,fields);
            const updatedSubaccounts = [...subaccountConfigs];
            // Updating the new subaccounts array with the new subaccount object
            updatedSubaccounts[subaccountIndex] = updatedValues;

            // updating the state subaccounts using the new array
            return setSubaccountConfigs(updatedSubaccounts);
        }
    }

    const onSearchDataUpdate = (searchData) => {
        if (Array.isArray(searchData)) {
            return setSubaccountConfigs(searchData);
        } else {
            return null;
        }
    }

    const resetUntouched = () => {
        // Going to reset the 'untouched' property for every accounts as they have been saved, this will hide the "save" button again.
        let newSubaccountsConfigs = [...subaccountConfigs]
        subaccountConfigs.forEach( (subaccount,i) => {
            newSubaccountsConfigs[i] = {
                ...subaccount,
                untouched:true
            }
        });
        setSubaccountConfigs(newSubaccountsConfigs);
        setDefaultConfigs({ ...defaultConfigs,untouched:true});
    }

    const saveSubaccount = async (subaccount,isDefault) => {
        // Rebuild the subscriptions detailedList property from the one we have now.
        let detailList = [];
        outputTypes.forEach(type => {
            const code = matchCodeUtil(type);
            const fieldLines = isDefault ? defaultConfigs.configs[type].fields : subaccount.configs[type].fields;
            fieldLines.forEach(line => {
                if(line === '' || line === ' ' || line === null || line === undefined) return; // Do not save empty values
                detailList.push({
                    "transmissionType": code,
                    "value": line
                });
            });
        });

        let updateObj = {
            "accountCode": userContext.user.account.accountCode,
            "subAccountCode": null,
            "language": i18n.language,
            "notificationType": notificationType,
            "detailList": detailList
        };
        if(!isDefault) updateObj["subAccountCode"] = subaccount.infos.subAccountCode; // We need to specify the subaccountcode when updating a subaccount
        console.log('[Notification.js] saving subaccount : ', updateObj);

        await axios.put(`/subAccounts/putNotificationSubscription`,updateObj)
            .then(response => {
                console.log('[Messages.js] saveSubaccount() axios results',response);
                toast.success(t('profile.notifications.saved'));
                return true;
            })
            .catch(error => console.log('[Messages.js] : Ajax error in saveSubaccount()',error.message));
    }

    const savingHandler = async () => {
        setSavingStatus(true);
        // process to save defaults
        if(defaultConfigs.untouched === false){
            await saveSubaccount(null,true);
        }
        // process to save specific accounts
        for(let subaccount of subaccountConfigs) {
            // As a UX improvement Going to save EVERY accounts that have been modified by the user.
            if(subaccount.untouched === false){
                await saveSubaccount(subaccount,false);
            }
        }

        setSavingStatus(false);
        resetUntouched();
    }

    const blocksSharedProps = {
        checkOutputType : checkOutputTypeHandler,
        addRemoveField : addRemoveFieldHandler,
        onInputChange : inputValueHandler,
        saveData : savingHandler,
        savingStatus : savingStatus
    }

    return (
        <div className="notification-management">
            <div className="notification-management__head">
                <h2 className="headline headline--section headline--uppercase">
                    {t("profile.notifications.title")}
                </h2>

                <div className="notification-management__section notification-management__section--all">
                    <div className="notification-management__titlebar">
                        <h2 className="notification-management__titlebar__title">
                            {t("profile.notifications.sections.all")}
                        </h2>
                    </div>
                    {
                        (loading || Object.keys(defaultConfigs).length === 0) ? <Spinner /> :
                            <Block subaccount={defaultConfigs}
                                   subaccountIndex={0}
                                   isDefault={true}
                                   {...blocksSharedProps}
                            />
                    }
                </div>
                <div className="notification-management__section">
                    <div className="notification-management__titlebar">
                        <div className="row">
                            <div className="col-md-3">
                                <h2 className="notification-management__titlebar__title">
                                    {t("profile.notifications.sections.each")}
                                </h2>
                            </div>
                            <div className="col-md-9">
                                <SearchForm data={originalData} currentData={subaccountConfigs} updateData={onSearchDataUpdate} />
                            </div>
                        </div>
                    </div>
                    {
                        (loading) ? <Spinner /> :
                        subaccountConfigs.map((subaccount,subaccountIndex) => {
                            return (
                                <Block subaccount={subaccount}
                                       subaccountIndex={subaccountIndex}
                                       isDefault={false}
                                       {...blocksSharedProps}
                                       key={'block-'+subaccountIndex}
                                />
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default Notifications;
